import { drop, map, pipe } from 'ramda';
import { Just, Nothing, orElse } from 'core/maybe';
const Red = (red)=>[
        'red',
        red
    ];
const Green = (green)=>[
        'green',
        green
    ];
const Blue = (blue)=>[
        'blue',
        blue
    ];
const Alpha = (alpha)=>[
        'alpha',
        alpha
    ];
const hex_digits = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F'
];
const parse = (value)=>{
    if (value.length !== 7) {
        return Nothing();
    }
    const split = value.split('#');
    if (split.length !== 2) {
        return Nothing();
    }
    const hex_digit_candidates = split[1].split('').map((x)=>x.toUpperCase());
    if (hex_digit_candidates.some((x)=>!hex_digits.includes(x))) {
        return Nothing();
    }
    return Just([
        '#',
        `${hex_digit_candidates[0]}${hex_digit_candidates[1]}`,
        `${hex_digit_candidates[2]}${hex_digit_candidates[3]}`,
        `${hex_digit_candidates[4]}${hex_digit_candidates[5]}`
    ]);
};
const empty = [
    '#',
    '00',
    '00',
    '00'
];
export const Hex = {
    parse,
    of: (value)=>orElse(empty)(parse(value)),
    toString: (hex)=>hex.join(''),
    toRgb: (hex)=>pipe(drop(1), map((h)=>`0x${h}`), map(parseInt), ([r, g, b])=>Rgb.of(Red(r), Green(g), Blue(b)))(hex)
};
const of = (name, hex)=>({
        name,
        variable: `--ozone-color-${name}`,
        hex: Hex.of(hex)
    });
const ColorDefinition = {
    of
};
export const colors = [
    ColorDefinition.of('cool_gray-10', '#f2f4f8'),
    ColorDefinition.of('cool_gray-20', '#dde1e6'),
    ColorDefinition.of('cool_gray-30', '#c1c7cd'),
    ColorDefinition.of('cool_gray-40', '#a2a9b0')
];
export const border = ColorDefinition.of('border', '#e0e0e0');
export const Rgba = {
    of: (red, green, blue, alpha)=>[
            'rgba',
            red[1],
            green[1],
            blue[1],
            alpha[1]
        ],
    toString: ([, ...values])=>`rgba(${values.join(',')})`,
    toRgb: (value)=>{
        const [, red, green, blue] = value;
        return Rgb.of(Red(red), Green(green), Blue(blue));
    }
};
export const Rgb = {
    of: (red, green, blue)=>[
            'rgb',
            red[1],
            green[1],
            blue[1]
        ],
    toString: ([, ...values])=>`rgba(${values.join(',')})`,
    toRgba: (alpha)=>(value)=>{
            const [, red, green, blue] = value;
            return Rgba.of(Red(red), Green(green), Blue(blue), Alpha(alpha));
        }
};
